/* ── Staff Management — Mock Data & Types ── */

export interface Staff {
    id: string;
    user_id: string;
    first_name: string;
    last_name: string | null;
    email: string;
    phone: string | null;
    employee_id: string;
    designation: string;
    department: string;
    joining_date: string;
    is_teacher: boolean;
    primary_subject_id: string | null;
    primary_subject_name: string | null;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export interface SubjectOption {
    id: string;
    name: string;
    code: string;
}

export const DEPARTMENTS = [
    'Mathematics',
    'Science',
    'Languages',
    'Social Science',
    'Computer Science',
    'Physical Education',
    'Arts & Music',
    'Administration',
    'Finance',
    'Student Affairs',
];

export const SUBJECT_OPTIONS: SubjectOption[] = [
    { id: 'sub1', name: 'Mathematics', code: 'MATH' },
    { id: 'sub2', name: 'Science', code: 'SCI' },
    { id: 'sub3', name: 'English', code: 'ENG' },
    { id: 'sub4', name: 'Hindi', code: 'HIN' },
    { id: 'sub5', name: 'Social Studies', code: 'SST' },
    { id: 'sub6', name: 'Computer Science', code: 'CS' },
    { id: 'sub7', name: 'Physical Education', code: 'PE' },
    { id: 'sub8', name: 'Art & Craft', code: 'ART' },
];

export const INITIAL_STAFF: Staff[] = [
    { id: 'st1', user_id: 'u1', first_name: 'Anjali', last_name: 'Sharma', email: 'anjali@school.edu', phone: '+91 9876543210', employee_id: 'EMP-001', designation: 'Head of Department', department: 'Mathematics', joining_date: '2015-07-01', is_teacher: true, primary_subject_id: 'sub1', primary_subject_name: 'Mathematics', is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st2', user_id: 'u2', first_name: 'Rajesh', last_name: 'Kumar', email: 'rajesh@school.edu', phone: '+91 9876543211', employee_id: 'EMP-002', designation: 'Senior Teacher', department: 'Languages', joining_date: '2016-06-15', is_teacher: true, primary_subject_id: 'sub4', primary_subject_name: 'Hindi', is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st3', user_id: 'u3', first_name: 'Priya', last_name: 'Patel', email: 'priya@school.edu', phone: '+91 9876543212', employee_id: 'EMP-003', designation: 'Teacher', department: 'Science', joining_date: '2018-04-01', is_teacher: true, primary_subject_id: 'sub2', primary_subject_name: 'Science', is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st4', user_id: 'u4', first_name: 'Suresh', last_name: 'Mehta', email: 'suresh@school.edu', phone: '+91 9876543213', employee_id: 'EMP-004', designation: 'Teacher', department: 'Social Science', joining_date: '2019-07-01', is_teacher: true, primary_subject_id: 'sub5', primary_subject_name: 'Social Studies', is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st5', user_id: 'u5', first_name: 'Kavita', last_name: 'Reddy', email: 'kavita@school.edu', phone: '+91 9876543214', employee_id: 'EMP-005', designation: 'Teacher', department: 'Languages', joining_date: '2020-01-10', is_teacher: true, primary_subject_id: 'sub3', primary_subject_name: 'English', is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st6', user_id: 'u6', first_name: 'Meena', last_name: 'Iyer', email: 'meena@school.edu', phone: '+91 9876543215', employee_id: 'EMP-006', designation: 'Sports Coach', department: 'Physical Education', joining_date: '2020-06-01', is_teacher: true, primary_subject_id: 'sub7', primary_subject_name: 'Physical Education', is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st7', user_id: 'u7', first_name: 'Vikram', last_name: 'Singh', email: 'vikram@school.edu', phone: '+91 9876543216', employee_id: 'EMP-007', designation: 'Office Manager', department: 'Administration', joining_date: '2017-03-15', is_teacher: false, primary_subject_id: null, primary_subject_name: null, is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st8', user_id: 'u8', first_name: 'Deepa', last_name: 'Nair', email: 'deepa@school.edu', phone: '+91 9876543217', employee_id: 'EMP-008', designation: 'Accountant', department: 'Finance', joining_date: '2019-01-05', is_teacher: false, primary_subject_id: null, primary_subject_name: null, is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st9', user_id: 'u9', first_name: 'Arjun', last_name: 'Desai', email: 'arjun@school.edu', phone: '+91 9876543218', employee_id: 'EMP-009', designation: 'Receptionist', department: 'Administration', joining_date: '2021-08-20', is_teacher: false, primary_subject_id: null, primary_subject_name: null, is_active: true, created_at: '2024-04-01', updated_at: '2025-01-15' },
    { id: 'st10', user_id: 'u10', first_name: 'Nandini', last_name: 'Rao', email: 'nandini@school.edu', phone: '+91 9876543219', employee_id: 'EMP-010', designation: 'Counselor', department: 'Student Affairs', joining_date: '2022-04-01', is_teacher: false, primary_subject_id: null, primary_subject_name: null, is_active: false, created_at: '2024-04-01', updated_at: '2024-11-30' },
];

const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

export async function fetchStaff(): Promise<Staff[]> {
    await delay(400);
    return INITIAL_STAFF;
}

export function getFullName(s: { first_name: string; last_name: string | null }): string {
    return s.last_name ? `${s.first_name} ${s.last_name}` : s.first_name;
}

export function getInitials(name: string): string {
    return name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2);
}
